import { render, staticRenderFns } from "./diagram.vue?vue&type=template&id=3d4ef0fa&"
import script from "./diagram.vue?vue&type=script&lang=js&"
export * from "./diagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports